import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Cached suggestion data (1 fetch per page load). */
let _cache = null;
let _pending = null;

export function useSuggestions() {
  const [data, setData] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    if (!_pending) {
      _pending = api.get("/suggestions").then((r) => {
        _cache = r.data || { directors: [], producers: [] };
        return _cache;
      }).catch(() => ({ directors: [], producers: [] }));
    }
    _pending.then((d) => setData(d));
  }, []);
  return data || { directors: [], producers: [] };
}

/** Force refresh of the cache (call after creating a project / saving). */
export function refreshSuggestions() { _cache = null; _pending = null; }

/** Simple text input wired to a <datalist> for native autocomplete.
 *  Props: value, onChange, options[], placeholder, className, "data-testid", id
 */
export function AutocompleteInput({ value, onChange, options, listId, ...rest }) {
  const id = listId || `dl-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <>
      <input
        type="text"
        list={id}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        {...rest}
      />
      <datalist id={id}>
        {(options || []).map((o) => (
          <option key={o} value={o} />
        ))}
      </datalist>
    </>
  );
}
